import { gql } from 'graphql-request';
import useGraphQLClient from '../../../app/hooks/useGraphQLClient';
import { useAuthContext } from '../../auth/contexts/AuthContext';
import { useQuery } from '@tanstack/react-query';

// http://localhost:8080/redirect/edm/0/document/156
const useDocumentRedirect = (edmId: number, documentEdmId: string) => {
	const authContext = useAuthContext();
	const graphQLClient = useGraphQLClient();

	// Liste des fonds de l'utilisateur
	const query = useQuery(
		['redirectDocument', edmId, documentEdmId],
		async () => {
			try {
				const data = (await graphQLClient.request(
					gql`
						query ($edmId: Int, $documentEdmId: String) {
							redirectDocument(edmId: $edmId, documentEdmId: $documentEdmId) {
								id
								name
								companies {
									id
									name
								}
							}
						}
					`,
					{
						edmId: edmId,
						documentEdmId: documentEdmId,
					},
				)) as { redirectDocument: { id: string; name: string; companies: { id: number; name: string }[] } };
				return data.redirectDocument;
			} catch (e) {
				return null;
			}
		},
		{
			// The query will not execute until the userId exists
			enabled: authContext.isAuthenticated,
		},
	);

	return query;
};

export default useDocumentRedirect;
